import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import LoginBackButton from "../../../components/SignUpLoginForgot/LoginBackButton";
import PowerGoAndSubheader from "../../../components/SignUpLoginForgot/PowerGoAndSubheader";
import ImgHeaderSubheader from "../../../components/SignUpLoginForgot/ImgHeaderSubheader";
import {
  LoginLayout,
  WidthWrapper,
  LoginInnerWrapperOther,
  OTPFieldsWrapper,
} from "../../../components/SignUpLoginForgot/LoginStyledComponents";
import Button from "../../../components/Button";
import OTPfield from "../../../components/OTPfield";
import { Colors, Text } from "../../../config";
import ErrorModal from "../../../components/ErrorSuccessModal/ErrorModal";
import { setPin } from "../../../services/userServices";
import { useLoaderContext } from "../../../contexts/loaderContext";

const saveIcon = require("../../../assets/images/save_icon.png");

const SignUpNewPin = () => {
  const navigate = useNavigate();
  const [newPin, setNewPin] = useState("");
  const [reEnterPin, setReEnterPin] = useState("");
  const [showNewPin, setShowNewPin] = useState(true);
  const [showReEnteredPin, setShowReEnteredPin] = useState(false);
  const buttonDisabled = newPin.length < 4 || reEnterPin.length < 4;
  const [backendErrorMsg, setBackendErrorMsg] = useState(false);
  const { setLoader } = useLoaderContext();

  const handleBackClick = () => {
    navigate("/auth/signup");
  };

  const closeErrorModal = () => {
    setBackendErrorMsg(false);
  };

  const handleSavePin = () => {
    console.log(newPin, reEnterPin);
    if (newPin !== reEnterPin) {
      setBackendErrorMsg(Text.enteredReEnteredDontMatch);
    } else {
      const newPinData = {
        userId: localStorage.getItem("userId"),
        pin: newPin,
      };
      postNewPin(newPinData);
    }
  };

  const postNewPin = async (newPinData) => {
    console.log(newPinData);
    setLoader(true);
    try {
      const response = await setPin(newPinData);
      console.log(response);
      if (response.status === 200) {
        setLoader(false);
        let responseData = response.data;
        localStorage.setItem("token", responseData.token);
        const employeeData = {
          firstName: responseData.firstName,
          lastName: responseData.lastName,
          email: responseData.email,
        };
        localStorage.setItem("employeeData", JSON.stringify(employeeData));
        navigate("/auth/signup/complete");
      }
    } catch (error) {
      setLoader(false);
      console.log(error);
      setBackendErrorMsg(error.message);
    }
  };

  return (
    <>
      <LoginBackButton onClick={handleBackClick} />
      <LoginLayout>
        <LoginInnerWrapperOther>
          <PowerGoAndSubheader />
          <WidthWrapper maxWidth="27rem">
            <ImgHeaderSubheader
              header={Text.createAFourDigitPin}
              subheader={Text.createAUniquePin}
            />
          </WidthWrapper>
          <OTPFieldsWrapper>
            <OTPfield
              label={Text.enterPin}
              uniqueName="pinNewSignup"
              getEnteredOTP={setNewPin}
              hiddenNeeded
              showHideOTP={showNewPin}
              setShowHideOTP={() => setShowNewPin(!showNewPin)}
              autoFocus
            />
            <OTPfield
              label={Text.reEnterYourPin}
              uniqueName="pinReSignup"
              getEnteredOTP={setReEnterPin}
              hiddenNeeded
              showHideOTP={showReEnteredPin}
              setShowHideOTP={() => setShowReEnteredPin(!showReEnteredPin)}
            />
          </OTPFieldsWrapper>
          <WidthWrapper maxWidth="22.5rem">
            <Button
              label={Text.savePin}
              onClick={handleSavePin}
              rightImgSrc={saveIcon}
              fontColor={Colors.white}
              fontSize="1.375rem"
              fontWeight="700"
              bgColor={Colors.brandTwo}
              topBottomPadding="0.75rem"
              labelImgGap="1rem"
              disabled={buttonDisabled}
            />
          </WidthWrapper>
        </LoginInnerWrapperOther>
      </LoginLayout>
      {backendErrorMsg && (
        <ErrorModal
          subheaderText={backendErrorMsg}
          setClose={closeErrorModal}
          onButtonClick={closeErrorModal}
        />
      )}
    </>
  );
};

export default SignUpNewPin;
